import { Link } from "react-router-dom";
import PageCTA from "@/components/PageCTA";

const Regulamin = () => (
  <div className="min-h-screen" data-testid="regulamin-page">
    <div className="bg-[var(--color-black)]" style={{ paddingTop: 100, paddingBottom: 40 }}>
      <div className="container">
        <div className="flex items-center gap-2 text-xs font-body text-[var(--color-text-light-muted)] mb-6">
          <Link to="/" className="hover:text-[var(--color-gold)] transition-colors">Strona główna</Link>
          <span>/</span>
          <span className="text-[var(--color-text-light)]">Regulamin</span>
        </div>
        <h1 className="font-heading text-[clamp(36px,5vw,52px)] text-[var(--color-text-light)]">
          Regulamin
        </h1>
      </div>
    </div>

    <div className="section bg-[var(--color-cream)]">
      <div className="container max-w-3xl mx-auto">
        <div className="font-body text-[var(--color-text-muted)] leading-relaxed space-y-8">
          <section>
            <h2 className="font-heading text-2xl font-medium text-[var(--color-text-dark)] mb-4">1. Postanowienia ogólne</h2>
            <p>Niniejszy regulamin określa zasady korzystania ze strony internetowej apisdesign.pl oraz warunki świadczenia usług przez ApisDesign.</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-medium text-[var(--color-text-dark)] mb-4">2. Definicje</h2>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li><strong className="text-[var(--color-text-dark)]">Usługodawca</strong> — ApisDesign, kontakt: aml01@vp.pl, tel. +48 507 334 540</li>
              <li><strong className="text-[var(--color-text-dark)]">Klient</strong> — osoba fizyczna lub prawna korzystająca z usług Usługodawcy</li>
              <li><strong className="text-[var(--color-text-dark)]">Usługi</strong> — projektowanie stron internetowych, grafik, materiałów reklamowych i inne usługi oferowane przez ApisDesign</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-medium text-[var(--color-text-dark)] mb-4">3. Zakres usług</h2>
            <p>ApisDesign świadczy usługi w zakresie:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>projektowania i tworzenia stron internetowych,</li>
              <li>projektowania grafik reklamowych i wizerunkowych,</li>
              <li>tworzenia identyfikacji wizualnej i logo,</li>
              <li>przygotowywania materiałów drukowanych,</li>
              <li>optymalizacji wizytówek Google,</li>
              <li>odzieży z nadrukiem.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-medium text-[var(--color-text-dark)] mb-4">4. Zamówienia i wycena</h2>
            <p>Zamówienie usługi następuje po przesłaniu zapytania przez formularz kontaktowy, e-mail lub WhatsApp. Wycena jest bezpłatna i niezobowiązująca. Realizacja projektu rozpoczyna się po zaakceptowaniu wyceny i wpłacie zaliczki (jeśli wymagana).</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-medium text-[var(--color-text-dark)] mb-4">5. Płatności</h2>
            <p>Płatność za usługi odbywa się przelewem bankowym na podstawie faktury VAT. Termin płatności wynosi 7 dni od daty wystawienia faktury, chyba że strony ustalą inaczej.</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-medium text-[var(--color-text-dark)] mb-4">6. Prawa autorskie</h2>
            <p>Przeniesienie praw autorskich do wykonanego projektu następuje po dokonaniu pełnej płatności. Do tego czasu projekt pozostaje własnością ApisDesign.</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-medium text-[var(--color-text-dark)] mb-4">7. Reklamacje</h2>
            <p>Reklamacje dotyczące realizacji usług należy zgłaszać na adres e-mail: aml01@vp.pl w terminie 14 dni od wykonania usługi. Reklamacja zostanie rozpatrzona w ciągu 14 dni roboczych.</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-medium text-[var(--color-text-dark)] mb-4">8. Postanowienia końcowe</h2>
            <p>ApisDesign zastrzega sobie prawo do zmiany regulaminu. Aktualna wersja regulaminu jest zawsze dostępna na stronie apisdesign.pl. W sprawach nieuregulowanych regulaminem zastosowanie mają przepisy prawa polskiego.</p>
          </section>
        </div>
      </div>
    </div>
  </div>
);

export default Regulamin;
